<template>
  <b-container class="mb-4">
      <b-card>
        <b-row>
            <b-col>
                <b-form @submit.prevent="createSport()">
                    <b-row>
                        <b-col>
                            <b-form-group label="Nombre del deporte">
                                <b-form-input v-model="form.name" type="text"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row class="mb-4">
                        <b-col>
                            <b-form-checkbox v-model="form.visible" name="check-button" switch inline>
                                Visible
                            </b-form-checkbox>
                        </b-col>
                    </b-row>

                    <b-button type="submit" variant="primary">Crear Categoría de Deporte</b-button>
                    <b-button @click="cancel" variant="none" class="iq-bg-danger ml-3">Cancelar</b-button>
                </b-form>
            </b-col>
        </b-row>
      </b-card>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import axios from 'axios'

export default {
  name: 'CrearCategoríaDeporte',
  data () {
    return {
      sports_types: [],
      form: {
        name: '',
        icon: '',
        position: null,
        visible: true
      }
    }
  },
  methods: {
    getSportsCategories () {
      axios.get('https://us-central1-atpro-app.cloudfunctions.net/api/sports_categories/all')
        .then(r => {
          this.sport_categories = r.data.data.map(e => {
            this.sports_types.push({value: e.id, text: e.name});
          })

          let arr = r.data.data.map(e => {
            return e.item.position
          })
          this.form.position = Math.max(...arr) + 1

        })
        .catch(e => {
          console.error('Error Sport Categories', e)
        })
    },
    createSport () {
      if(this.form.name === "") {
        return alert('Debes ingresar un nombre para la categoría de deporte')
      }
      axios.post('https://us-central1-atpro-app.cloudfunctions.net/api/sports_categories/create', this.form)
        .then(r => {
          console.log('Sport created!', r.data.data)
          this.$router.push({ name: 'atpro.sports-categories' })
        })
        .catch(e => {
          console.error('Error Sport', e)
        })
    },
    cancel () {
      this.$router.push({ name: 'atpro.sports-categories' })
    }
  },
  mounted () {
    core.index()
    this.getSportsCategories()
  }
}
</script>
